function initFeaturedCollections() {
  const sections = document.querySelectorAll('.shopify-section--featured-collections:not([data-initialized])');
  sections.forEach(section => {
    section.setAttribute('data-initialized', 'true');
    const tabButtons = section.querySelectorAll('.tabs-nav__item');
    const productLists = section.querySelectorAll('product-list');

    tabButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        tabButtons.forEach(b => b.setAttribute('aria-expanded', 'false'));
        btn.setAttribute('aria-expanded', 'true');

        productLists.forEach(list => list.setAttribute('hidden', ''));
        section.querySelectorAll('.featured-collections__view-all').forEach(el => el.setAttribute('hidden', ''));
        
        const targetId = btn.getAttribute('aria-controls');
        if (targetId) {
          const targetList = section.querySelector('#' + targetId);
          if (targetList) {
            targetList.removeAttribute('hidden');
          }
          const targetViewAllId = targetId.replace('block-', 'view-all-');
          const targetViewAll = section.querySelector('#' + targetViewAllId);
          if (targetViewAll) {
            targetViewAll.removeAttribute('hidden');
          }
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initFeaturedCollections);

document.addEventListener('shopify:section:load', function(e) {
  const targetSection = e.target.classList.contains('shopify-section--featured-collections') 
    ? e.target 
    : e.target.querySelector('.shopify-section--featured-collections');
  if (targetSection) {
    targetSection.removeAttribute('data-initialized');
  }
  initFeaturedCollections();
});